import { Fetcher } from '@this/src/util';
import type Hotel from '@this/domain/hotel/hotel';

interface RestrictedHotel {
  searchQueryItemId?: number;
  elementId: string;
  selectedStayPlanId: string;
  hotelName: string;
  roomName: string;
  planName: string;
}

interface Props {
  sendLog?: boolean;
  searchQueryId?: number;
  restrictedHotels: RestrictedHotel[];
  onCompleted?: () => void;
  onError?: (error: string) => void;
}

interface CompletedResponse {
  success: boolean;
}

interface ErrorResponse {
  errors?: string[];
}

const convertHotelToRestrictedHotel = (hotel: Hotel): RestrictedHotel => {
  const selectedPlan = hotel.stay_plans?.find(plan => plan.id === hotel.selected_stay_plan_id);
  const roomName = selectedPlan?.room_name || hotel.room_type || '';
  const planName = selectedPlan?.name || hotel.plan_name || '';

  return {
    elementId: hotel.id || '',
    searchQueryItemId: hotel.search_query_item_id || undefined,
    selectedStayPlanId: hotel.selected_stay_plan_id || '',
    hotelName: hotel.name || '',
    roomName,
    planName
  };
};

const restrictedHotelPlanLogAPI = ({
  sendLog = false,
  searchQueryId,
  restrictedHotels,
  onCompleted,
  onError
}: Props) => {
  if (!sendLog || restrictedHotels.length === 0) {
    return;
  }

  const params = {
    search_query_id: searchQueryId,
    restricted_hotels: restrictedHotels.map(hotel => ({
      search_query_item_id: hotel.searchQueryItemId,
      element_id: hotel.elementId,
      selected_stay_plan_id: hotel.selectedStayPlanId,
      hotel_name: hotel.hotelName,
      room_name: hotel.roomName,
      plan_name: hotel.planName
    }))
  };

  Fetcher.post<CompletedResponse>('/restricted_hotel_plan_logs', params)
    .then(() => onCompleted?.())
    .catch((error: ErrorResponse) => onError?.(error.errors?.join('\n') || '予期せぬエラーが発生しました'));
};

export type RestrictedHotelPlanLogAPIProps = Partial<Props>;
export { convertHotelToRestrictedHotel };

export default restrictedHotelPlanLogAPI;
